<template>
  <div class="count-down-timer">
    <slot :timeInfo="{ day, hour, minute, second }">
      <div class="default-timer">
        <span class="number">{{day}}</span> 天 <span class="number">{{hour}}</span> 小时 <span class="number">{{minute}}</span> 分钟后过期
      </div>
    </slot>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    initLeftTime: Number, // 初始化剩余时间
    endDate: String, // 结束时间
    delay: Number, // 倒计时间隔
  },
  data() {
    return {
      timer: null,
      leftTime: 0, // 剩余时间
    };
  },
  computed: {
    day() {
      const value = parseInt(this.leftTime / (24 * 60 * 60), 0);
      return value > 9 ? value : `0${value}`;
    },
    hour() {
      const value = parseInt(this.leftTime / (60 * 60) % 24, 0);
      return value > 9 ? value : `0${value}`;
    },
    minute() {
      const value = parseInt(this.leftTime / 60 % 60, 0);
      return value > 9 ? value : `0${value}`;
    },
    second() {
      const value = parseInt(this.leftTime % 60, 0);
      return value > 9 ? value : `0${value}`;
    },
  }, 
  created() {
    if (this.initLeftTime) {
      this.leftTime = this.initLeftTime && this.initLeftTime > 0 ? this.initLeftTime : 0;
    }

    this.timeDown();
  },
  destroyed() {
    this.timer && clearInterval(this.timer);
  },
  methods: {
    timeDown() {
      if (!this.initLeftTime && this.endDate) {
        const endDate = this.checkTimeFormat(this.endDate) ? moment(this.endDate) : moment(`${this.endDate} 23:59:59`);
        this.leftTime = endDate.valueOf() - new Date().valueOf() > 0 ? (endDate.valueOf() - new Date().valueOf()) / 1000 : 0;
      } else {
        if (this.leftTime <= 0) {
          this.timer && clearInterval(this.timer);
          return;
        }
        this.leftTime = this.leftTime - 1;
      }

      // 优化处理--大于一天的一分钟刷一次，因为很多是显示到分的
      let defaultDelay = 1000;
      if (this.day > 0) {
        defaultDelay = 1000 * 60;
      }

      this.timer = setTimeout(() => {
        this.timeDown();
      }, this.delay || defaultDelay);
    },

    // 检查是否携带时分秒
    checkTimeFormat(timeString) {
      const timeRegex = /\d{2}:\d{2}:\d{2}/;  
      if (timeRegex.test(timeString)) {
        return true;
      } 
      return false;
      
    },
  },
};

</script>

<style lang="less" scoped>
.count-down-timer {
  .default-timer {
    color: #FF6464;
    line-height: 18px;
    .number {
      background: #FF6464;
      border-radius: 2px;
      color: #fff;
      padding: 0 2px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/activity/count-down-timer.vue